/*
*###############################################################################
*Module Name                   : ProductManage.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Tuesday, Octorber 4th 2022, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import ReactPaginate from 'react-paginate'
import { GetGroupDetails } from './ProductManageController'


const ProductManageContent = ({

    disabled,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    ErrorMsg,
    menuName,
    menuCode,
    DataTable,
    userCode,
    userDesc,
    SetUserCode,
    Hed_SelectUserRow,
    modal_xlarge2,
    tog_xlarge2,
    setAlertMsg,
    setAlertColor,
    setShow,
    userOnblur,
    syncLocations,
    GetsyncLocations,
    addNew,
    groupList,
    SetupGroup,
    SetDatatable
}) => {
    const ApiURL = window.Links.ApiURL
    //*** useState to save table data */


    const [locationColumns, setLocationColumns] = useState([])
    const [stationColumns, setStationColumns] = useState([])
    const [groupFilter, SetGroupFilter] = useState("a")
    const [groupName, SetGroupName] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(10)


    useEffect(async () => {

        const responseData = await GetGroupDetails(SetupGroup)

        if (responseData.success && responseData.data.length > 0 && SetupGroup != 0) {
            SetGroupName(responseData.data[0].gS_FILENAME)
        }

    }, [SetupGroup])


    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    function handleRemoveRowBarcode(id) {

        const objectIndex = DataTable.filter(obj => obj.id != id);
        SetDatatable(objectIndex);

    }


    const changeRowValueChanges = (value, id, element) => {

        const objectIndex = DataTable.findIndex(obj => obj.id === id);
        const newObject = { ...DataTable[objectIndex], [element]: value };
        SetDatatable(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };


    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataTable.slice(indexOfFirstPost, indexOfLastPost)

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Row className="mb-1">
                                <Col sm={12} md={12} className="mb-4-sm">
                                    <Label style={{ marginLeft: "15px" }}>Assigned Group Level {SetupGroup} "{groupName}"</Label>
                                </Col>
                            </Row>
                            <Row className="mb-2 mt-1">
                                <Col sm={12} md={2} className="mb-4-sm">
                                    <Label style={{ marginLeft: "15px" }}>User ID</Label>
                                </Col>
                                <Col sm={12} md={2} className="mb-4-sm">
                                    <DPTextBoxforgrid
                                        value={userCode}
                                        onChange={SetUserCode}
                                        disabled={disabled ? true : addNew ? false : true}
                                        onBlur={userOnblur}
                                    />
                                </Col>
                                <Col sm={12} md={3} className="mb-4-sm">
                                    <DPTextBoxforgrid
                                        value={userDesc}
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm={12} md={1} className="mb-4-sm" style={{ padding: 0 }}>
                                    <Button
                                        onClick={() => {
                                            tog_xlarge2()
                                        }}
                                        color="success"
                                        className="btn-sm"
                                        disabled={disabled}
                                    >
                                        <i
                                            className="mdi mdi-search-web"
                                            style={{ fontSize: "12px" }}
                                        ></i>
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} md={2} className="mb-4-sm">
                                    <Button
                                        style={{ marginLeft: "12px" }}
                                        onClick={GetsyncLocations}
                                        color="primary"
                                        className="btn-sm"
                                        disabled={disabled ? true : syncLocations}
                                    >
                                        Locations
                                    </Button>
                                </Col>

                            </Row>


                            <Row>
                                <Col className="mb-2-sm">

                                    {DataTable.length > 0 ?
                                        <table style={{ fontSize: "11px" }} className='mt-2' id={"promodetails"}>
                                            <thead >
                                                <tr>
                                                    <th>#</th>
                                                    <th>Location Code</th>
                                                    <th>Location Description</th>
                                                    <th>Station ID</th>
                                                    <th>Groups Allowed</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (currentPosts || []).map((item, index) => {
                                                        return (
                                                            <TableRow
                                                                FormRow={item}
                                                                Key={index}
                                                                handleRemoveRowBarcode={handleRemoveRowBarcode}
                                                                Disabled={disabled}
                                                                locationColumns={locationColumns}
                                                                stationColumns={stationColumns}
                                                                menuCode={menuCode}
                                                                setAlertMsg={setAlertMsg}
                                                                setAlertColor={setAlertColor}
                                                                setShow={setShow}
                                                                changeRowValueChanges={changeRowValueChanges}
                                                                indexOfFirstPost={indexOfFirstPost}
                                                            />
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table> : null}

                                </Col>
                            </Row>
                            <Row>
                                <Col md="10">
                                    <ReactPaginate
                                        previousLabel={'Previous'}
                                        nextLabel={'Next'}
                                        breakLabel={'...'}
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        pageCount={Math.ceil(DataTable.length / postsPerPage)}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        forcePage={currentPage - 1}
                                        renderOnZeroPageCount={null}
                                        activeClassName={'active'}
                                        activeLinkClassName={'page-link'}
                                        containerClassName={'pagination justify-content-center pagination-sm'}
                                    />
                                </Col>
                            </Row>

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"PRODUCT"}
                                MenuCode={menuCode}
                                KeyVal={"PRO"}
                                searchBy={"MP_CODE"}
                                FilterStr={groupFilter}
                            />

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={"User Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modal_xlarge2}
                                toggle={tog_xlarge2}
                                getSelect={Hed_SelectUserRow}
                                APIURL={ApiURL}
                                URLPath={"USER"}
                                MenuCode={menuCode}
                                KeyVal={"USE"}
                                searchBy={"UH_ID"}
                                FilterStr={groupFilter}
                            />


                        </Row>
                    </CardText>

                </Col>
            </div>
        </React.Fragment>
    )
}


export default ProductManageContent



const TableRow = ({ FormRow, Key, RemoveRow, Disabled, handleRemoveRowBarcode, changeRowValueChanges, indexOfFirstPost }) => {


    return (
        <tr key={FormRow.id}>
            <td style={{ width: "30px" }}>
                {indexOfFirstPost + Key + 1}
            </td>
            <td style={{ width: "150px" }}>

                <DPTextBoxforgrid
                    textAlign={"left"}
                    id={"locCode" + Key}
                    value={FormRow.locCode}
                    disabled={true}
                />

            </td>
            <td style={{ width: "400px" }}>
                <DPTextBoxforgrid
                    textAlign={"left"}
                    id={"locDesc" + Key}
                    value={FormRow.locDesc}
                    disabled={true}
                />
            </td>
            <td style={{ width: "100px" }}>
                <DPTextBoxforgrid
                    textAlign={"left"}
                    id={"stationID" + Key}
                    value={FormRow.stationID}
                    disabled={true}
                />
            </td>
            <td style={{ width: "150px" }}>
                <DPTextBoxforgrid
                    textAlign={"left"}
                    id={"groups" + Key}
                    value={FormRow.groups}
                    onChange={(e) => {
                        changeRowValueChanges(e.target.value, FormRow.id, "groups")
                    }}
                    disabled={Disabled}
                />
            </td>
            <td >
                <Button
                    outline
                    disabled={Disabled}
                    color="danger"
                    onClick={e => {
                        handleRemoveRowBarcode(FormRow.id)
                    }}
                    size="sm"
                >
                    <i className="fa fa-trash" style={{ fontSize: "12px" }}></i>
                </Button>
            </td>
        </tr>
    )

}
